import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Popover, TableRow, MenuList, MenuItem, menuItemClasses, TableCell, Chip } from '@mui/material';

import { Agent } from '../../../types/UserTypes';
import { Iconify } from '../../../core/iconify';
import { paths } from '../../../../utils/paths';
import { BVTConstants } from '../../../../utils/BVTConstants';

type AgentTableRowProps = {
  row: Agent;
};

export function TableRowAgent({ row }: AgentTableRowProps) {
  const [openPopover, setOpenPopover] = useState<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  const handleOpenPopover = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenPopover(event.currentTarget);
  }, []);

  const handleClosePopover = useCallback(() => {
    setOpenPopover(null);
  }, []);

  const handleVerify = useCallback(() => {
    setOpenPopover(null);
  }, []);
  

  return (
    <>
      <TableRow 
        hover 
        tabIndex={-1}
        onClick={() => navigate(paths.admin.viewAgent, { state: { agentId: row.agentId } })}
        sx={{ cursor: 'pointer' }}
      >
        <TableCell component="th" scope="row">
          {/* <Box gap={2} display="flex" alignItems="center">
            <Avatar alt={row.name} src={row.avatarUrl} /> */}
            {row.displayName}
          {/* </Box> */}
        </TableCell>

        <TableCell>
          {row.companyName.length > 12 
            ? `${row.companyName.substring(0, 12)}...` 
            : row.companyName}
        </TableCell>
        <TableCell>{row.contact}</TableCell>
        
        <TableCell align="center">
          <Chip
            label={String(row.isPrimary) === 'true' ? 'YES' : 'NO'}
            size="small"
            color={String(row.isPrimary) === 'true' ? 'success' : 'warning'}
          />
        </TableCell>

        <TableCell align="center">
          {String(row.isVerified) === 'true' ? (
            <Iconify width={22} icon="eva:checkmark-circle-2-fill" sx={{ color: 'success.main' }} />
          ) : (
            <Iconify width={22} icon="eva:close-circle-fill" sx={{ color: 'error.main' }} />
          )}
        </TableCell>

        <TableCell align="center">
        <Chip
            label={row.status === BVTConstants.PARENT_INACTIVE ? BVTConstants.INACTIVE : row.status}
            size="small"
            sx={{
              backgroundColor: 
                row.status === BVTConstants.ACTIVE ? '#e8f5e8' :
                row.status === BVTConstants.INACTIVE ? '#ffebee' :
                row.status === BVTConstants.PARENT_INACTIVE ? '#ffebee' :
                row.status === BVTConstants.SUSPENDED ? '#fff3e0' : '#f5f5f5',
              color: 
                row.status === BVTConstants.ACTIVE ? 'green' :
                row.status === BVTConstants.INACTIVE ? 'red' :
                row.status === BVTConstants.PARENT_INACTIVE ? 'red' :
                row.status === BVTConstants.SUSPENDED ? 'orange' : 'grey',
              fontWeight: 'bold',
              border: 
                row.status === BVTConstants.ACTIVE ? '1px solid green' :
                row.status === BVTConstants.INACTIVE ? '1px solid red' :
                row.status === BVTConstants.PARENT_INACTIVE ? '1px solid red' :
                row.status === BVTConstants.SUSPENDED ? '1px solid orange' : '1px solid grey',
            }}
          />
          
        </TableCell>

        {/* <TableCell align="right">
          <IconButton onClick={handleOpenPopover}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell> */}
      </TableRow>

      <Popover
        open={!!openPopover}
        anchorEl={openPopover}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList
          disablePadding
          sx={{
            p: 0.5,
            gap: 0.5,
            width: 180,
            display: 'flex',
            flexDirection: 'column',
            [`& .${menuItemClasses.root}`]: {
              px: 1,
              gap: 2,
              borderRadius: 0.75,
              [`&.${menuItemClasses.selected}`]: { bgcolor: 'action.selected' },
            },
          }}
        >

          
          {String(row.isVerified) === 'true' ? (
              <MenuItem onClick={handleClosePopover}>
                <Iconify icon="solar:pen-bold" /> View Certificate
              </MenuItem>
            ) : (
              <MenuItem onClick={handleVerify}>
                <Iconify icon="solar:pen-bold" /> Verify
              </MenuItem>
          )}
          
          <MenuItem 
            onClick={handleClosePopover} 
            sx={{ color: 'error.main' }}
          >
            <Iconify icon="solar:archive-check-bold" />
            {row.status === BVTConstants.ACTIVE 
              ? 'Deactivate' 
              : 'Activate'}
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
}
